module.exports = __webpack_public_path__ + "@/assets/img/cursor.b33d3d7e.svg";